
<div class="card">
  <div class="card-body">
    <div class="card-title d-flex justify-content-between">
      <h6 class="font-weight-bold">HP Color Laser Jet Managed MFP E8765 XYZ</h6>
      <div>
        <div><b class="mr-1">Billing Initiation:</b><span>{{ asset.billingInitiation }}</span></div>
        <div><b class="mr-1">Status:</b><span>{{ statuses[asset.status] }}</span></div>
      </div>
    </div>
    <div class="progress mb-2" style="height: 10px;">
      <div class="progress-bar border-right border-white" [ngStyle]="{'width.%': '25'}" *ngFor="let i of coloredStatusesLength"></div>
      <div class="progress-bar" style="width: 25%; background-color: #efefef;" [ngStyle]="{'width.%': '25'}" *ngFor="let x of uncoloredStatusesLength; let i = index" [ngClass]="{'border-left': i !== 0, 'border-secondary': i !== 0}"></div>
    </div>
    <div class="row">
      <div class="col d-flex align-items-center flex-column"><span>Processing</span><small class="text-muted">{{ asset.statusHistory["Processing"] | date:"yyyy-MM-dd" }}</small></div>
      <div class="col d-flex align-items-center flex-column"><span>Acknowledged</span><small class="text-muted">{{ asset.statusHistory["Acknowledged"] | date:"yyyy-MM-dd" }}</small></div>
      <div class="col d-flex align-items-center flex-column"><span>Production</span><small class="text-muted">{{ asset.statusHistory["Production"] | date:"yyyy-MM-dd" }}</small></div>
      <div class="col d-flex align-items-center flex-column"><span>Shipped</span><small class="text-muted">{{ asset.statusHistory["Shipped to Customer"] | date:"yyyy-MM-dd" }}</small></div>
      <div class="col d-flex align-items-center flex-column"><span>Delivered</span><small class="text-muted">{{ asset.statusHistory["Delivered"] | date:"yyyy-MM-dd" }}</small></div>
    </div>
    <div class="row mt-5">
      <div class="col-md-6">
        <table class="table table-borderless hp-table-striped">
          <tbody>
            <tr>
              <th>Order Date</th>
              <td>{{ asset.orderDate }}</td>
            </tr>
            <tr>
              <th>Sales Order No.</th>
              <td>{{ asset.salesOrderNumber }}</td>
            </tr>
            <tr>
              <th>SKU</th>
              <td>{{ asset.sku }}</td>
            </tr>
            <tr>
              <th>Device Key</th>
              <td>{{ asset.deviceKey }}</td>
            </tr>
            <tr>
              <th>Building</th>
              <td>{{ asset.building }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <table class="table table-borderless hp-table-striped">
          <tbody>
            <tr>
              <th>Floor</th>
              <td>{{ asset.floor }}</td>
            </tr>
            <tr>
              <th>Map ID</th>
              <td>{{ asset.mapId }}</td>
            </tr>
            <tr>
              <th>Serial Number</th>
              <td>{{ asset.serialNumber }}</td>
            </tr>
            <tr>
              <th>MAC Address</th>
              <td>{{ asset.serialNumber }}</td>
            </tr>
            <tr>
              <th>IP Address</th>
              <td>{{ asset.serialNumber }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>